import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/allForFieldReportFilter`;

export const ROUTE: RouteDefinition = `${baseRoute}/allForFieldReportFilter`;

export const URL = (): RouteDefinition => `${baseRoute}/allForFieldReportFilter`;
